import { Box, Image, Text, useColorMode, Flex } from 'native-base'
import React, { useState, useRef, useEffect } from 'react'
import { ScrollView, Linking } from 'react-native'
import {
  heightPercentageToDP as hp,
  widthPercentageToDP as wp
} from 'react-native-responsive-screen'
import styles from './styles'

import { useTheme } from '../../../../ThemeProvider.tsx'

import { useNavigation, useRoute } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import StorageUtil from '../../../../Utils'
import { TouchableOpacity, Dimensions } from 'react-native'
import agenda from '../../../img/historico.png'
import pacotes from '../../../img/pacotes.png'
import estrela from '../../../img/avaliar.png'
import voltar from '../../../img/voltar.png'
import logout from '../../../img/sair.png'
import ItemMenu from './ItemMenu'
import MenuNovo, { BotaoMenuNovo } from './MenuNovo'
import { CommonActions } from '@react-navigation/native'
import LogoLoginBanner from '../../../img/logo_app.png'
import LogoMaiorBanner from '../../../img/logo_app.png'
import Anonimo from '../../../img/anonimo.png'
import { TitleItem } from '../../../components/Title/Index'
import Api from '../../../../Api/Api'
import { MaterialCommunityIcons } from '@expo/vector-icons'

const Menu: React.FC = () => {
  let timer = useRef<any>(0)
  const { getCodEmpresa, configEmpresa, getCodigoEmpresa, primaryColor } =
    useTheme()

  const navigation = useNavigation<any>()

  const { width: SCREEN_WIDTH } = Dimensions.get('window')

  const scrollViewRef = useRef<ScrollView | null>(null)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [dadosCliente, setDadosCliente] = useState<any>({})
  const [estatisticas, setEstatisticas] = useState({
    agendamentosRealizados: 0,
    pacotesUtilizados: 0
  })
  const [carregandoEstatisticas, setCarregandoEstatisticas] = useState(true)

  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa)
  )

  const backgroundColor = getConfigEmpresa.coresPWA.corFundo

  const { colorMode } = useColorMode()

  const route = useRoute()

  const handleOpenURL = (url: string) => {
    Linking.canOpenURL(url).then((supported) => {
      if (supported) {
        Linking.openURL(url)
      } else {
        console.log('Não foi possível abrir a URL: ' + url)
      }
    })
  }

  const botoes = [
    getConfigEmpresa && getConfigEmpresa.agendaPacotePeloPwa
      ? {
          label: 'Pacotes',
          subtitulo: 'Planos e saldo de usos',
          iconeNovo: 'package',
          icon: pacotes,
          onPress: () =>
            navigation.navigate('Pacotes', {
              id_empresa: getCodEmpresa,
              idCliente: route.params.idCliente
            })
        }
      : null,
    {
      label: 'Histórico',
      subtitulo: 'Seus atendimentos anteriores',
      iconeNovo: 'rotate-ccw',
      icon: agenda,
      onPress: () =>
        navigation.navigate('Historico', {
          id_empresa: getCodEmpresa,
          idCliente: route.params.idCliente
        })
    },
    {
      label: 'Avalie',
      subtitulo: 'Conte como foi seu corte',
      iconeNovo: 'star',
      icon: estrela,
      onPress: () => {
        const url =
          'https://portal.agendasimplificada.com.br/#/feedback-empresa?reference=' +
          getCodigoEmpresa
        handleOpenURL(url)
      }
    },
    dadosCliente && dadosCliente.admin
      ? {
          label: 'Clientes',
          subtitulo: 'Pessoas vinculadas à conta',
          iconeNovo: 'users',
          icon: Anonimo,
          onPress: () =>
            navigation.navigate('Clientes', {
              id_empresa: getCodEmpresa,
              idCliente: route.params.idCliente
            })
        }
      : null
  ]

  const images = [LogoLoginBanner, LogoMaiorBanner]

  useEffect(() => {
    clearInterval(timer.current)
    getDadosCliente()
    getEstatisticas()

    // setTimeout(() => {
    //     navigation.navigate("Historico", { id_empresa: getCodEmpresa, idCliente: route.params.idCliente })
    // }, 1000);

    startTimer()
    return () => closeTimer()
  }, [])

  async function getDadosCliente() {
    const value = await StorageUtil.getItem('cliente')

    if (value) {
      setDadosCliente(value)
    }
  }

  async function getEstatisticas() {
    try {
      const value = await StorageUtil.getItem('cliente')
      if (!value) return

      setCarregandoEstatisticas(true)

      // Buscar histórico de agendamentos
      const historicoResponse = await Api.historicoCliente(
        value.id,
        getCodEmpresa
      )
      const agendamentosRealizados = historicoResponse.status
        ? historicoResponse.data.length
        : 0

      // Buscar pacotes do cliente
      const pacotesResponse = await Api.pacotesCliente(getCodEmpresa, value.id)
      const pacotesUtilizados = pacotesResponse.status
        ? pacotesResponse.data.length
        : 0

      setEstatisticas({
        agendamentosRealizados,
        pacotesUtilizados
      })
    } catch (error) {
      console.error('Erro ao buscar estatísticas:', error)
    } finally {
      setCarregandoEstatisticas(false)
    }
  }

  function startTimer() {
    timer.current = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      )
    }, 5000 * 50)
  }

  function closeTimer() {
    clearInterval(timer.current)
  }

  useEffect(() => {
    scrollViewRef.current?.scrollTo({
      x: currentIndex * SCREEN_WIDTH,
      animated: true
    })
  }, [currentIndex])

  const executaMenu = async (id: number) => {
    if (id == 1) {
      navigation.dispatch(
        CommonActions.reset({
          index: 0,
          routes: [{ name: 'TabNavigator', params: { screen: 'Inicio' } }]
        })
      )
    } else if (id == 2) {
      await StorageUtil.removeItem('cliente')
      navigation.dispatch(
        CommonActions.reset({
          index: 0,
          routes: [{ name: 'TabNavigator', params: { screen: 'Inicio' } }]
        })
      )
    }
  }

  function recuperarNome(nome: string) {
    if (nome) {
      const arrayNome = nome.split(' ')
      return (
        (arrayNome[0] ? arrayNome[0] : '') +
        (arrayNome[1] ? ' ' + arrayNome[1] : '')
      )
    }
    return ''
  }

  const Header = () => {
    return (
      <Box
        style={[
          styles.header,
          {
            backgroundColor:
              getConfigEmpresa.coresPWA.corFundoHeaderAreaCliente || '#fff',
            paddingVertical: 15,
            paddingHorizontal: 20,
            borderBottomLeftRadius: 20,
            borderBottomRightRadius: 20,
            shadowColor: '#000',
            shadowOffset: {
              width: 0,
              height: 2
            },
            shadowOpacity: 0.1,
            shadowRadius: 3,
            elevation: 3,
            borderWidth: 1,
            borderColor: getConfigEmpresa.coresPWA.corBordaPrimaria || '#000'
          }
        ]}
      >
        <Flex direction='row' alignItems='center'>
          <Box
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              borderRadius: 12,
              padding: 8,
              width: 40,
              height: 40,
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: 15
            }}
          >
            <ItemMenu
              onClick={(id: number) => executaMenu(id)}
              onClose={() => startTimer()}
              onOpen={() => closeTimer()}
            />
          </Box>

          <Box style={{ flex: 1 }}>
            <Text
              style={[
                styles.tituloHeader,
                {
                  fontSize: 24,
                  fontWeight: 'bold',
                  color:
                    getConfigEmpresa.coresPWA.corFonteHeaderAreaCliente ||
                    '#000'
                }
              ]}
            >
              Olá {recuperarNome(dadosCliente.nome)}
            </Text>
            <Text
              style={{
                fontSize: 14,
                opacity: 0.8,
                marginTop: 2,
                color:
                  getConfigEmpresa.coresPWA.corFonteHeaderAreaCliente || '#000'
              }}
            >
              Bem-vindo à sua área
            </Text>
          </Box>
        </Flex>
      </Box>
    )
  }

  const Carrocel = () => {
    return (
      <Box style={styles.boxBanner}>
        <ScrollView
          ref={scrollViewRef}
          horizontal
          pagingEnabled
          showsHorizontalScrollIndicator={false}
        >
          {images.map((source: string, index: number) => (
            <Image
              key={index}
              source={{ uri: source }}
              style={{ width: wp('100%'), height: '100%' }}
              resizeMode='cover'
              alt='item'
            />
          ))}
        </ScrollView>
      </Box>
    )
  }

  const Botoes = () => {
    const item = []

    const botoesValidos = botoes.filter((item) => item != null)

    let index = 0
    for (let i = 0; i < botoesValidos.length; i += 2) {
      item.push(
        <Box style={styles.containerItem} key={index}>
          <Box style={styles.buttonContainer}>
            <TouchableOpacity
              style={[
                styles.buttonWrapper,
                {
                  backgroundColor: backgroundColor,
                  borderColor: getConfigEmpresa.coresPWA.corBordaItens
                }
              ]}
              onPress={() => {
                if (!botoesValidos[i].disabled && botoesValidos[i].onPress) {
                  botoesValidos[i].onPress()
                }
              }}
            >
              <Box style={styles.iconContainer}>
                <Image
                  source={{ uri: botoesValidos[i].icon }}
                  alt='Logo'
                  style={styles.icon}
                  resizeMode='cover'
                />
              </Box>
            </TouchableOpacity>

            {botoesValidos[i].disabled && (
              <Box style={styles.overlayBox}>
                <Text
                  style={[
                    styles.overlayText,
                    { color: getConfigEmpresa.coresPWA.corFontePrimaria }
                  ]}
                  fontSize={'xl'}
                >
                  Em Breve
                </Text>
              </Box>
            )}

            <Box style={styles.buttonContainer}>
              <Text
                style={[
                  styles.label,
                  { color: getConfigEmpresa.coresPWA.corFontePrimaria }
                ]}
                fontSize={'xl'}
              >
                {botoesValidos[i].label}
              </Text>
            </Box>
          </Box>

          {botoesValidos[i + 1] ? (
            <Box style={styles.buttonContainer}>
              <TouchableOpacity
                style={[
                  styles.buttonWrapper,
                  {
                    backgroundColor: backgroundColor,
                    borderColor: getConfigEmpresa.coresPWA.corBordaItens
                  }
                ]}
                onPress={() => {
                  if (
                    !botoesValidos[i + 1].disabled &&
                    botoesValidos[i + 1].onPress
                  ) {
                    botoesValidos[i + 1].onPress()
                  }
                }}
              >
                <Box style={styles.iconContainer}>
                  <Image
                    source={{ uri: botoesValidos[i + 1].icon }}
                    alt='Logo'
                    style={styles.icon}
                    resizeMode='cover'
                  />
                </Box>
              </TouchableOpacity>

              {botoesValidos[i + 1].disabled && (
                <Box style={styles.overlayBox}>
                  <Text
                    style={[
                      styles.overlayText,
                      { color: getConfigEmpresa.coresPWA.corFontePrimaria }
                    ]}
                    fontSize={'xl'}
                  >
                    Em Breve
                  </Text>
                </Box>
              )}

              <Box style={styles.buttonContainer}>
                <Text
                  style={[
                    styles.label,
                    {
                      color: getConfigEmpresa.coresPWA.corFontePrimaria
                    }
                  ]}
                  fontSize={'xl'}
                >
                  {botoesValidos[i + 1].label}
                </Text>
              </Box>
            </Box>
          ) : (
            <Box
              style={{
                width: '40%'
              }}
            ></Box>
          )}
        </Box>
      )

      index++
    }

    return item
  }

  const utilizacaoLayoutV2 =
    getConfigEmpresa.utilizaLayoutV2 || getConfigEmpresa.utilizaPwaSimples

  function novoAgendamento() {
    if (utilizacaoLayoutV2) {
      window.location.reload()
    } else {
      navigation.navigate('InicioStack', {
        screen: 'Profissional',
        params: {
          id_empresa: getCodEmpresa
        }
      })
    }
  }

  // ---------------- Layout novo ----------------
  // O modo legado (pwa simples / layout v2 / tema escuro) continua com o layout antigo
  const utilizaLayoutLegado =
    getConfigEmpresa.utilizaPwaSimples ||
    getConfigEmpresa.versaoPWA == 2 ||
    getConfigEmpresa.utilizaTemaEscuro

  if (!utilizaLayoutLegado) {
    return (
      <MenuNovo
        corPrincipal={primaryColor || '#006400'}
        nomeCliente={dadosCliente.nome || ''}
        nomeEmpresa={getConfigEmpresa.nomeFantasia || ''}
        estatisticas={estatisticas}
        carregandoEstatisticas={carregandoEstatisticas}
        botoes={botoes.filter((item) => item != null) as BotaoMenuNovo[]}
        onNovoAgendamento={novoAgendamento}
        onMenuConta={(id: number) => executaMenu(id)}
      />
    )
  }

  // ---------------- Layout legado ----------------
  return (
    <Box style={{ flex: 1, position: 'relative' }}>
      <Box flex={1} backgroundColor={backgroundColor}>
        <Header />
        <Box style={[styles.container, { backgroundColor: backgroundColor }]}>
          <br />
          <TitleItem
            title={'Menu'}
            subtitle='Selecione uma das opções abaixo'
            icon={{
              name: 'microsoft',
              size: 24
            }}
          />
          <Box
            style={[styles.boxConteudo, { backgroundColor: backgroundColor }]}
          >
            {/* Box de Estatísticas */}
            <Box
              style={{
                backgroundColor: getConfigEmpresa.coresPWA.corFundo || '#fff',
                borderRadius: 15,
                padding: 20,
                marginBottom: 20,
                marginTop: 10,
                marginHorizontal: 10,
                borderWidth: 1,
                borderColor:
                  getConfigEmpresa.coresPWA.corBordaPrimaria || '#e0e0e0',
                shadowColor: '#000',
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.1,
                shadowRadius: 4,
                elevation: 3
              }}
            >
              <Text
                style={{
                  fontSize: 18,
                  fontWeight: 'bold',
                  color: getConfigEmpresa.coresPWA.corFontePrimaria || '#000',
                  marginBottom: 15,
                  textAlign: 'center'
                }}
              >
                Resumo da Conta
              </Text>

              <Flex
                direction='row'
                justifyContent='space-between'
                alignItems='center'
              >
                {/* Agendamentos Realizados */}
                <Flex
                  direction='column'
                  alignItems='center'
                  style={{ flex: 1 }}
                >
                  <MaterialCommunityIcons
                    name='calendar-check'
                    size={32}
                    color={getConfigEmpresa.coresPWA.corFontePrimaria || '#000'}
                    style={{ marginBottom: 8 }}
                  />
                  <Text
                    style={{
                      fontSize: 24,
                      fontWeight: 'bold',
                      color:
                        getConfigEmpresa.coresPWA.corFontePrimaria || '#000',
                      marginBottom: 4
                    }}
                  >
                    {carregandoEstatisticas
                      ? '...'
                      : estatisticas.agendamentosRealizados}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      color:
                        getConfigEmpresa.coresPWA.corFonteSecundaria || '#666',
                      textAlign: 'center'
                    }}
                  >
                    Agendamentos{'\n'}Realizados
                  </Text>
                </Flex>

                {/* Separador vertical */}
                <Box
                  style={{
                    width: 1,
                    height: 60,
                    backgroundColor:
                      getConfigEmpresa.coresPWA.corBordaPrimaria || '#e0e0e0',
                    marginHorizontal: 20
                  }}
                />

                {/* Pacotes Utilizados */}
                <Flex
                  direction='column'
                  alignItems='center'
                  style={{ flex: 1 }}
                >
                  <MaterialCommunityIcons
                    name='package-variant'
                    size={32}
                    color={getConfigEmpresa.coresPWA.corFontePrimaria || '#000'}
                    style={{ marginBottom: 8 }}
                  />
                  <Text
                    style={{
                      fontSize: 24,
                      fontWeight: 'bold',
                      color:
                        getConfigEmpresa.coresPWA.corFontePrimaria || '#000',
                      marginBottom: 4
                    }}
                  >
                    {carregandoEstatisticas
                      ? '...'
                      : estatisticas.pacotesUtilizados}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      color:
                        getConfigEmpresa.coresPWA.corFonteSecundaria || '#666',
                      textAlign: 'center'
                    }}
                  >
                    Pacotes{'\n'}Utilizados
                  </Text>
                </Flex>
              </Flex>
            </Box>
            <Botoes />
          </Box>
        </Box>
      </Box>

      {/* FAB - Floating Action Button - Fixo na tela */}
      <TouchableOpacity
        style={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          width: 56,
          height: 56,
          borderRadius: 28,
          backgroundColor: '#007AFF',
          justifyContent: 'center',
          alignItems: 'center',
          shadowColor: '#000',
          shadowOffset: {
            width: 0,
            height: 4
          },
          shadowOpacity: 0.3,
          shadowRadius: 4.65,
          elevation: 8,
          zIndex: 9999
        }}
        onPress={novoAgendamento}
      >
        <MaterialCommunityIcons name='calendar-plus' size={24} color='#fff' />
      </TouchableOpacity>
    </Box>
  )
}

export default Menu
